import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import $api from '@/plugins/axiosInstance.js'
import $api2 from '@/plugins/axiosInstance2.js'
import CONST from '@/const.js'
import last from 'lodash/last'

const state = {
  originArtistList: [],
  artistList: [],
  variousArtist: {},
  selectedAlbumArtistIds: [],
  selectedAlbumVariousArtists: false,
  selectedTrackArtistListIds: [],
  selectedTrackVariousArtists: false,

  originGenreList: [],
  genreList: [],
  selectedAlbumGenreListIds: [],
  selectedTrackGenreListIds: [],

  trackInfoList: [],
  /* --------------------------------------- */
  /* Album List */
  /* --------------------------------------- */
  albumListQueryData: {},
  selectedAlbum: {},
}

const getters = {
  
}

const mutations = {
 
}

const actions = {
  LIST_ALBUM: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/album', params: payload}).then((result) => {
        return result.data
      })
    }
  },
  LIST_ALBUM_V2: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: '/admin/album/list', params: payload }).then((result) => {
        return result.data
      })
    }
  },
  
  POST_ALBUM: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'post', url: '/album', data: payload}).then(result =>{
          return result
      })
    }
  },
  DELETE_ALBUM: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'delete', url: '/album/'+payload.id}).then(result =>{
          return result
      })
    }
  },

  POST_EXCEL_ALBUM: {
    root:true,
    handler(namespacedContext, payload) {
      return $api({
        method: 'post', 
        url: `/licensor/${payload.id}/album/import`, 
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: payload.params}).then(result =>{
          return result
      })
    }
    
  },
  PUT_ALBUM: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'put', url: '/album/'+payload.id, data: payload.params})
        .then(result =>{
          return result
        })
    }
  },
  PUT_ALBUM_V2: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({method: 'put', url: '/admin/album/'+payload.id, data: payload.params})
        .then(result =>{
          return result
        })
    }
  },
   
  PUT_REJECT_ALBUM: {
    root: true,
    handler(namespacedContext, payload) {
      ///album/{id}/reject
      return $api({method: 'put', url: '/album/'+payload.id+'/reject', data: payload.params})
        .then(result =>{
          return result
        })
    }
  },
  GET_ALBUM: {
    root: true,
    handler(namespacedContext, payload) {
     
      return $api({ method: 'get', url: '/album/'+payload.id,}).then((result) => {
        return result
      })
    }
  },
  GET_ALBUM_V2: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: '/admin/album/'+payload.id,}).then((result) => {
        return result
      })
    }
  },
  
  GET_CONTRIBUTORS_V2: {
    root: true,
    handler(namespacedContext, payload) {
       let id = payload.id
      delete payload.id
      return $api2({ method: 'get', url: `/admin/album/${id}/contributors_v2`,params: payload}).then((result) => {
        return result.data
      })
    }
  },

  POST_CONTRIBUTOR_V2: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'post', url: `/contributor_v2`, data: payload }).then((result) => {
        return result.data
      })
    }
  },

  PUT_CONTRIBUTOR_V2: {
    root: true,
    handler(namespacedContext, payload) {
      const { id, ...data } = payload
      return $api2({ method: 'put', url: `/contributor_v2/${id}`, data }).then((result) => {
        return result.data
      })
    }
  },
  
  POST_ALBUM_TRACK: {
    root: true,
    handler(namespacedContext, payload) { 
      return $api({ method: 'post', url: `/album/${payload.id}/tracks`,data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  POST_ALBUM_TRACK_V2: {
    root: true,
    handler(namespacedContext, payload) { 
      return $api2({ method: 'post', url: `/admin/album/${payload.id}/track`,data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  PUT_ALBUM_TRACK: {
    root: true,
    handler(namespacedContext, payload) { 
      return $api({ method: 'put', url: `/album/${payload.id}/tracks/${payload.params.id}`,data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  PUT_ALBUM_TRACK_V2: {
    root: true,
    handler(namespacedContext, payload) { 
      return $api2({ method: 'put', url: `/admin/album/${payload.id}/track/${payload.params.id}`,data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  GET_ALBUM_TRACK_LIST: {
    root: true,
    handler(namespacedContext, id) { 
      return $api({ method: 'get', url: `/album​/${id}​/tracks`}).then((result) => {
        return result.data
      })
    }
  },

  DELETE_ALBUM_TRACK: {
    root: true,
    handler(namespacedContext, payload) { 
      return $api({ method: 'delete', url: `/album/${payload.id}/tracks/${payload.track_id}`}).then((result) => {
        return result.data
      })
    }
  },
  POST_ALBUM_EXCEL: {
    root: true,
    handler(namespacedContext, payload) { 
      const formData = new FormData()
      formData.append('file', payload.file)
      formData.set('json', JSON.stringify(payload.params))
      return $api({  method: 'post', url: `/licensor/${payload.licensor_id}/album/import`,headers: {
        'Content-Type': 'multipart/form-data',
        },data: formData,}).then((result) => {
        return result
      })
    }
  },
  DELETE_AUDIO_FILE: {
    root: true,
    handler(namespacedContext, payload) { 
      return  $api({
        method: 'delete',
        url: `/album/${payload.album_id}/tracks/${payload.track_id}/file/${payload.id}`,
      }).then((result) => {
        return result
      }).catch((err) => reject(err))
    }
  },
  LIST_MATCHTABLE_ALBUM_CODE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: `/album/${payload.id}/matchtable/code`, params: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  LIST_MATCHTABLE_ALBUM_NAME: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: `/album/${payload.id}/matchtable/name`, params: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  LIST_MATCHTABLE_TRACK_CODE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: `/album/${payload.id}/tracks/matchtable/code`, params: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  LIST_MATCHTABLE_TRACK_NAME: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: `/album/${payload.id}/tracks/matchtable/name`, params: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  GENERATE_CONTRACKT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: `/album/${payload.id}/generate-contract`}).then((result) => {
        return result.data
      })
    }
  },
  ALBUM_LINK_LIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: `/album/${payload.id}/link`}).then((result) => {
        return result.data
      })
    }
  },
  ALBUM_LINK_POST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'post', url: `/album/${payload.id}/link`, data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  
  ALBUM_LINK_PUT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'put', url: `/album/${payload.id}/link/${payload.link_id}`,data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  ALBUM_SMARTLINK_PUT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'put', url: `/album/${payload.id}/link`,data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  ALBUM_LINK_DELETE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'delete', url: `/album/${payload.id}/link/${payload.link_id}`}).then((result) => {
        return result.data
      })
    }
  },
  ALBUM_LINK_GENERATE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: `/album/${payload.id}/link/generate`}).then((result) => {
        return result.data
      })
    }
  },
  ALBUM_LINK_ADDRESS_EDIT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'put', url: `/album/${payload.id}/link/rename`,data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  GET_ALBUM_VIDEO: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/album/'+payload.id+'/video', params: payload.params}).then((result) => {
        return result
      })
    }
  },
  POST_ALBUM_VIDEO: {
    root: true,
    handler(namespacedContext, payload) { 
      return $api({ method: 'post', url: `/album/${payload.id}/video`,data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  PUT_ALBUM_VIDEO: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'put', url: `/album/${payload.id}/video/${payload.video_id}`,data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  
  DELETE_ALBUM_VIDEO: {
    root: true,
    handler(namespacedContext, payload) { 
      return $api({ method: 'delete', url: `/album/${payload.id}/video/${payload.video_id}`}).then((result) => {
        return result.data
      })
    }
  },
  GET_ALBUM_VIDEO_DETAIL: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/album/'+payload.id+'/video', }).then((result) => {
        return result
      })
    }
  },

  GET_RELEASE_NOTICE_EXCEL: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/album/export/releasenotice', params: payload, responseType: 'blob' })
        .then(result =>{return result})
    }
  },
  GET_ALBUM_LIST_EXCEL: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/album/export', params: payload, responseType: 'blob' })
        .then(result =>{return result})
    }
  },
  GET_INGESTION_HISTORY: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: `/album/${payload.id}/ingestion-history`, params: payload.params })
        .then(result =>{return result})
    }
  },
  GET_DJ_HISTORY: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: `/album/${payload.id}/export-history`, params: payload.params })
        .then(result => { return result })
    }
  },
  GET_ALBUM_DELIVERY_TRACKER: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: '/admin/album/delivery-tracker', params: payload })
        .then(result => result.data)
    }
  },
  GET_EXPORT_CONTRACT_V2: {
    root: true,
    handler() {
      return $api2({ method: 'get', url: '/admin/export-contract' })
        .then(result => result.data)
    }
  },
  GET_ALBUM_MEMO_V2: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: `/admin/album/${payload.id}/memo`, params: payload.params })
        .then(result => result)
    }
  },
  POST_ALBUM_MEMO_V2: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'post', url: `/admin/album/${payload.id}/memo`, data: payload.params })
        .then(result => result)
    }
  },
  DELETE_ALBUM_MEMO_V2: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'delete', url: `/admin/album/${payload.id}/memo/${payload.memo_id}` })
        .then(result => result)
    }
  },
  PUT_ALBUM_CONTRACT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'put', url: `/album/${payload.id}/contract`,data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  PUT_ALBUM_LICENSOR: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'put', url: `/album/${payload.id}/contract/licensors`,data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  POST_ALBUM_MASSIVE: {
    root: true,
    handler (namespacedContext, payload) {
      const formData = new FormData()
      formData.append('file', payload.file)
      return $api({
        method: 'post',
        url: `/album/massive-transfer`,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      }).then((result) => {
        return result
      })
    }
  },
  POST_TRANS_FILE: {
    root: true,
    handler(namespacedContext, payload) { 
      return $api({  method: 'post', url: `/album/${payload.id}/transcode `,data: payload.params,}).then((result) => {
        return result.data
      })
    }
  },
  GET_SPECTROGRAM: {
    root: true,
    handler (namespacedContext, payload) {
      //album/:album_id/track/:track_id/file/:file_id/spectrogram
      return $api({  method: 'get', url: `/album/${payload.id}/tracks/${payload.track_id}/file/${payload.file_id}/spectrogram `,data: payload.params,}).then((result) => {
        return result.data
      })
    }
  },

  ALBUM_RELEASE_MONITORING_LIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: `/album/${payload.id}/release_monitoring`,params: payload.params} ).then((result) => {
        return result.data
      })
    }
  },
  ALBUM_RELEASE_MONITORING_POST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'post', url: `/album/${payload.id}/release_monitoring`, data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  ALBUM_RELEASE_MONITORING_PUT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'put', url: `/album/${payload.id}/release_monitoring/${payload.release_monitoring_id}`,data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  ALBUM_RELEASE_MONITORING_DELETE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'delete', url: `/album/${payload.id}/release_monitoring/${payload.release_monitoring_id}`}).then((result) => {
        return result.data
      })
    }
  },
  POST_ALBUM_CODE_GENERATE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'post', url: `/admin/album/${payload.id}/generate-codes`, data: payload.params }).then((result) => {
        return result.data
      })
    }
  },

  GET_ISRC_PREFIX_STATISTICS: {
    root: true,
    handler() {
      return $api2({ method: 'get', url: '/admin/isrc-prefix/statistics' })
        .then((result) => result.data)
    }
  },

  GET_ISRC_PREFIXES: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: '/admin/isrc-prefix', params: payload })
        .then((result) => result.data)
    }
  },

  GET_BARCODE_PREFIX_STATISTICS: {
    root: true,
    handler() {
      return $api2({ method: 'get', url: '/admin/barcode-prefix/statistics' })
        .then((result) => result.data)
    }
  },

  GET_BARCODE_PREFIXES: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: '/admin/barcode-prefix', params: payload })
        .then((result) => result.data)
    }
  },

  GET_BARCODE_PREFIX_LOGS: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: '/admin/barcode-prefix/logs', params: payload })
        .then((result) => result.data)
    }
  },

  POST_BARCODE_PREFIX: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'post', url: '/admin/barcode-prefix', data: payload })
        .then((result) => result.data)
    }
  },

  PATCH_BARCODE_PREFIX: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'patch', url: `/admin/barcode-prefix/${payload.id}`, data: payload.params })
        .then((result) => result.data)
    }
  },

  POST_ISRC_PREFIX: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'post', url: '/admin/isrc-prefix', data: payload })
        .then((result) => result.data)
    }
  },

  PATCH_ISRC_PREFIX: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'patch', url: `/admin/isrc-prefix/${payload.id}`, data: payload.params })
        .then((result) => result.data)
    }
  },

  GET_CODE_GENERATION_EXPORTS: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'get', url: '/admin/album/code-generation/exports', params: payload })
        .then((result) => result.data)
    }
  },

  POST_CODE_GENERATION_EXPORT: {
    root: true,
    handler() {
      return $api2({ method: 'post', url: '/admin/album/code-generation/export', responseType: 'arraybuffer' })
    }
  },

  PUT_BARCODE_GENERATE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'put', url: `/admin/album/${payload.id}/barcode`, data: payload.params }).then((result) => {
        return result.data
      })
    }
  },
  PUT_ISRC_GENERATE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'put', url: `/admin/track/${payload.id}/isrc`, data: payload.params }).then((result) => {
        return result.data
      })
    }
  },
  PUT_DOLBY_ISRC_GENERATE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api2({ method: 'put', url: `/admin/track/${payload.id}/dolbyatmos-isrc`, data: payload.params }).then((result) => {
        return result.data
      })
    }
  },
  GET_GENRE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/genre'}).then((result) => {
        return result.data
      })
    }
  },
  POST_GENRE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'post', url: '/genre', data: payload}).then((result) => {
        return result
      })
    }
  },
  PUT_GENRE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'put', url: '/genre/'+ payload.id, data: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  DELETE_GENRE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'delete', url: '/genre/'+payload.id, }).then((result) => {
        return result.data
      })
    }
  },
  GET_LICENSOR_ARTIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: `/licensor/${payload.licensor_id}/artist`, params: payload.params}).then((result) => {
        return result.data
      })
    }
  },


  uciGenerate ({ commit }, albumId) {
    // url: [PUT] /album/:albumId/generate-uci
    return new Promise((resolve, reject) => {
      $api({
        method: 'put',
        url: `/album/${albumId}/generate-uci`,
      }).then((res) => resolve(res)).catch((err) => reject(err))
    })
  },
  mimsImport ({ commit }, xmlFile) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('file', xmlFile)
      $api({
        method: 'put',
        url: "/album/mims-import",
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      }).then((res) => resolve(res)).catch((err) => reject(err))
    })
  },
  mimsExport ({ commit }, albumId) {
    return new Promise((resolve, reject) => {
      $api({
        method: "get",
        url: `/album/${albumId}/mims-export`,
        responseType: 'blob'
      }).then((res) => {
        const fileURL = window.URL.createObjectURL(new Blob([res.data]))
        const fileLink = document.createElement('a')
        const header = res.headers['content-disposition']

        let fileName = "unknown"
        if (header) {
          fileName = decodeURIComponent(last(header.split('\'\'')))
        }

        fileLink.href = fileURL
        fileLink.setAttribute('download', `${fileName}`)
        document.body.appendChild(fileLink)
        fileLink.click()
        resolve(res)
      }).catch((err) => reject(err))
    })
  },
  DELETE_MOTIONART11: {
    root: true,
    handler(namespacedContext, payload) { 
      return  $api({
        method: 'delete',
        url: `/album/${payload.album_id}/motionart11`,
      }).then((result) => {
        return result
      }).catch((err) => reject(err))
    }
  },
  DELETE_MOTIONART34: {
    root: true,
    handler(namespacedContext, payload) { 
      return  $api({
        method: 'delete',
        url: `/album/${payload.album_id}/motionart34`,
      }).then((result) => {
        return result
      }).catch((err) => reject(err))
    }
  },
  DELETE_DOLBY_FILE: {
    root: true,
    handler(namespacedContext, payload) {
      return  $api({
        method: 'delete',
        url: `/album/${payload.album_id}/tracks/${payload.track_id}/dolbyatmos`,
      }).then((result) => {
        return result
      }).catch((err) => reject(err))
    }
  },
  DELETE_APPLE_DIGITAL_MASTER_FILE: {
    root: true,
    handler(namespacedContext, payload) {
      return  $api2({
        method: 'delete',
        url: `/admin/track/${payload.track_id}/appledigitalmaster`,
      }).then((result) => {
        return result
      }).catch((err) => reject(err))
    }
  },
  POST_ATTACH_TRACK_FILE: {
    root: true,
    handler(namespacedContext, payload) {
      const form = new FormData()
      form.append('file', payload.file, payload.file.name)
      form.append('mapping', JSON.stringify([{ filename: payload.file.name, track_id: payload.track_id }]))
      return $api2({
        method: 'post',
        url: `/admin/album/${payload.album_id}/track/attach-files`,
        data: form,
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          if (payload.onProgress) {
            payload.onProgress(Math.round((e.loaded / (e.total || 1)) * 100))
          }
        },
      }).then(({ data }) => data)
    }
  },
  POST_ONLY_FILE : {
    root: true,
    handler(namespacedContext, payload) {
      const formData = new FormData()
      formData.append('file', payload.file, payload.file.name)
    //   return $api({ method: 'post', url: '/file', data: formData, headers: {
    //     'content-Type': 'multipart/form-data'
    // }, timeout: 30000})
    //     .then(result =>{
    //       return result
    //     })
      return $api({method: 'post', url:'/file',data: formData, headers: {
        'content-Type': 'multipart/form-data'
      }})
      .then(result => {
        return result.data
      })
    }
  },
  DELETE_ONLY_FILE: {
    root: true,
    handler(namespacedContext, payload) { 
      return  $api({
        method: 'delete',
        url: `/file/${payload.id}`,
      }).then((result) => {
        return result.data
      }).catch((err) => reject(err))
    }
  },
  
  /* 미사용 ------------------------------------------------------------------------ */
  getGenreObject ({ commit }) {
    // url: [GET] /genre
    return new Promise((resolve, reject) => {
      $api({
        method: 'get',
        url: '/genre',
      }).then((res) => {
        commit('SET_MUSIC_GENRE_LIST', res.data.items)
        resolve('ok')
      }).catch((err) => {
        commit('SET_MUSIC_GENRE_LIST', [])
        reject(err)
      })
    })
  },
  POST_SMARTLINK_NOTIFICATION: {
    root: true,
    handler (namespacedContext, payload) {
      return $api({ method: 'post', url: '/album/' + payload.id + '/notification/smartlink', data: payload.params }).then(result =>{
        return result
      })
    }
  },

  uploadImageFile ({ commit }, imageFile) {
    // url: [POST] /file
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('file', imageFile)
      $api({
        method: 'post',
        url: '/file',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: formData
      }).then((res) => resolve(res.data)).catch((err) => reject(err))
    })
  },
  deleteImageFile ({ commit }, uri) {
    // url: [DELETE] /album/:albumId/coverimage, /album/:albumId/labelimage
    return new Promise((resolve, reject) => {
      $api({
        method: 'delete',
        url: uri,
      }).then((res) => resolve(res)).catch((err) => reject(err))
    })
  },
  queryAlbumList ({ commit }, param) {
    // url: [GET] /album
    return new Promise((resolve, reject) => {
      $api({
        method: 'get',
        url: '/album',
        params: param
      }).then((res) => {
        commit('SET_ALBUM_DATA', res.data)
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  selectedAlbumQuery ({ commit }, albumId) {
    // url: [GET] /album/:albumId
    return new Promise((resolve, reject) => {
      $api({
        method: 'get',
        url: `/album/${albumId}`,
      }).then((res) => {
        commit('MUTATE_SELECTED_ALBUM', { type: 'set', album: res.data })
        commit('RESTORE_TRACK_LIST', res.data.tracks)
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  deleteAlbumArtist ({ commit }, target) {
    // url: [DELETE] /album/:albumId/artist/:artistId
    return new Promise((resolve, reject) => {
      $api({
        method: 'delete',
        url: `/album/${target.albumId}/artist/${target.artistId}`,
      }).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  insertAlbumArtist ({ commit }, target) {
    // url: [POST] /album/:albumId/aritst
    return new Promise((resolve, reject) => {
      $api({
        method: 'post',
        url: `/album/${target.albumId}/artist`,
        data: { id: target.artistId },
      }).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  deleteTrackArtist ({ commit }, target) {
    // url: [DELETE] /album/:albumId/tracks/:trackId/artist/:artistId
    return new Promise((resolve, reject) => {
      $api({
        method: 'delete',
        url: `/album/${target.albumId}/tracks/${target.trackId}/artist/${target.artistId}`,
      }).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  insertTrackArtist ({ commit }, target) {
    // url: [POST] /album/:albumId/tracks/:trackId/artist
    return new Promise((resolve, reject) => {
      $api({
        method: 'post',
        url: `/album/${target.albumId}/tracks/${target.trackId}/artist`,
        data: { id: target.artistId },
      }).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  getTrackInfo ({ commit }, payload) {
    // url: [GET] /album/:albumId/tracks/:trackId
    return new Promise((resolve, reject) => {
      $api({
        method: 'get',
        url: `/album/${payload.albumId}/tracks/${payload.id}`,
      }).then((res) => resolve(res.data)).catch((err) => reject(err))
    })
  },
  insertTrack ({ commit }, saveData) {
    // url: [POST] /album/:albumId/tracks
    return new Promise((resolve, reject) => {
      $api({
        method: 'post',
        url: `/album/${saveData.albumId}/tracks`,
        data: saveData.trackInfo,
      }).then((res) => resolve(res)).catch((err) => reject(err))
    })
  },
  deleteTrack ({ commit }, info) {
    // url: [DELETE] /album/:albumId}/tracks/:trackId
    return new Promise((resolve, reject) => {
      $api({
        method: 'delete',
        url: `/album/${info.albumId}/tracks/${info.trackId}`,
      }).then((res) => resolve(res)).catch((err) => reject(err))
    }) 
  },
  updateTrack ({ commit }, updateData) {
    // url: [PUT] /album/:albumId/tracks/:trackId
    return new Promise((resolve, reject) => {
      $api({
        method: 'put',
        url: `/album/${updateData.albumId}/tracks/${updateData.trackId}`,
        data: updateData.trackInfo,
      }).then((res) => resolve(res)).catch((err) => reject(err))
    })
  },
  deleteContributor ({ commit }, info) {
    // url: [DELETE] /admin/track/:trackId/contributors/:contributorId
    return new Promise((resolve, reject) => {
      $api2({
        method: 'delete',
        url: `/admin/track/${info.trackId}/contributors/${info.id}`,
      }).then((res) => resolve(res)).catch((err) => reject(err))
    })
  },
  deleteTrackFile ({ commit }, info) {
    // url: [DELETE] /album/:albumId/tracks/:trackId/file/:fileId
    return new Promise((resolve, reject) => {
      $api({
        method: 'delete',
        url: `/album/${info.albumId}/tracks/${info.trackId}/file/${info.id}`,
      }).then((res) => resolve(res)).catch((err) => reject(err))
    })
  },
  
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
